import { z } from 'zod';

export const ROLE_KEYS = ['super_admin', 'admin', 'mlo', 'processor', 'readonly'] as const;
export type RoleKey = (typeof ROLE_KEYS)[number];
export const RoleKeySchema = z.enum(ROLE_KEYS);

export const ROLE_LABELS: Record<RoleKey, string> = {
  super_admin: 'Super Administrator',
  admin: 'Administrator',
  mlo: 'Mortgage Loan Originator',
  processor: 'Processor',
  readonly: 'Read-only',
};

/** Roles that satisfy admin-or-better access checks. */
export const ADMIN_TIER_ROLES: readonly RoleKey[] = ['super_admin', 'admin'];

/** Helper: is this role admin-or-better? */
export const isAdminTier = (role: RoleKey): boolean => ADMIN_TIER_ROLES.includes(role);

/** Helper: is this role specifically super_admin (platform-level)? */
export const isSuperAdmin = (role: RoleKey): boolean => role === 'super_admin';

export interface ModulePermissionFlags {
  canView: boolean;
  canEdit: boolean;
  canAdmin: boolean;
}

export const NO_ACCESS: ModulePermissionFlags = { canView: false, canEdit: false, canAdmin: false };
export const VIEW_ONLY: ModulePermissionFlags = { canView: true, canEdit: false, canAdmin: false };
export const FULL_EDIT: ModulePermissionFlags = { canView: true, canEdit: true, canAdmin: false };
export const FULL_ADMIN: ModulePermissionFlags = { canView: true, canEdit: true, canAdmin: true };
